// Path: box/Panel.js
import { toPx } from './utils/common';

const _defaults = {
  
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  
  angle: 0,

  // is panel printable or not, as part of outside print
  print: true,
  
  // is panel printable or not, as part of inside print
  printInside: true,

  // @TODO document this, with available values
  cameraRotationH: 'none',
  cameraRotationV: 'none',
  cameraRotationHInside: 'none',
  cameraRotationVInside: 'none',
  
  /**
   * Should the lid be open or closed when this panel is active
   * Options: 'open', 'closed', 'current'
   */
  lid: 'current',
};

export default class Panel {
  
  constructor(config) {
    
    // Merge defaults with user provided config
    this.config = {
      ..._defaults, 
      ...config
    };

    // Dynamically create getters and setters for the properties
    Object.keys(this.config).forEach(prop => {
      Object.defineProperty(this, prop, {
          get: function() {
              const value = this.config[prop];
              return typeof value === 'function' ? value.call(this) : value;
          },
          set: function(newValue) {
              // console.log('panel setter called', prop, newValue);
              this.config[prop] = newValue;
          },

          enumerable: true,
          configurable: true
      });
    });
    
    const pxProperties = [
      'width', 
      'height', 
      'top', 
      'left',
    ];

    pxProperties.forEach(prop => {
      Object.defineProperty(this, `${prop}Px`, {
          get: function() {
              return toPx(this[prop]);
          },
          enumerable: true,
          configurable: true
      });
    });

  }
}